import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { archiveSave } from '../../features/dashboard/ArchiveSlice';
import Header from './Header';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';

import Broadcast from './Broadcast';

function Archive() {

    const [name, setName] = useState();
    const [manager, setManager] = useState();
    const [code, setCode] = useState();
    const [phone, setPhone] = useState();
    const [address, setAddress] = useState();
    const [status, setStatus] = useState(false)

    const dispatch = useDispatch();
    let {
        archives,
        rahpardaznetLoading,
        rahpardaznetSuccess,
        rahpardaznetMessage,
        errorName,
        errorManager,
        errorCode,
        errorPhone,
        errorAddress
    } = useSelector(state => state.archive)

    const data = {
        'name': name,
        'manager': manager,
        'code': code,
        'phone': phone,
        'address': address
    }

    const storeSaveHandler = (event) => {
        event.preventDefault();
        setStatus(true)
        dispatch(archiveSave(data));

        
    }

    useEffect(() => {
        if (rahpardaznetSuccess === true && rahpardaznetMessage != null) {
            setName('')
            setManager('')
            setCode('')
            setPhone('')
            setAddress('')
            toast.success(rahpardaznetMessage, {
                position: "top-center",
                autoClose: 1200,
            })
            
        }else if(rahpardaznetSuccess === false && rahpardaznetMessage != null){
            
            if(rahpardaznetMessage){
                toast.error(rahpardaznetMessage, {
                    position: "top-center",
                    autoClose: 1200,
                })
            }
           
        }

    }, [rahpardaznetLoading, rahpardaznetSuccess, rahpardaznetMessage])

    return (
        <>
            {rahpardaznetLoading ? (<Loading />) : null}
            <Broadcast title={'ثبت انبار جدید'} />
            <form className="text-end">
                <div className='row rahpardaznet-cart my-5 print-position'>
                    <div className=" row col-12">
                        <div className="col-12 col-md-6 ">
                            <div className="row m-3 rahpardaznet-form-controll">
                                <label htmlhtmlFor="staticEmail" className="fw-bold text-end form-label px-1">
                                    نام انبار
                                </label>
                                <input
                                    tabIndex="1"
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    className="form-control shadow-none"
                                    id="staticName"
                                    autoFocus
                                />
                                {
                                    (errorName) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger validate-error'>{errorName}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>
                        <div className="col-12 col-md-6">

                            <div className="row m-3 rahpardaznet-form-controll">
                                <label htmlhtmlFor="staticEmail" className="fw-bold text-end form-label px-1">
                                    مدیر انبار
                                </label>
                                <input
                                    tabIndex="2"
                                    type="text"
                                    value={manager}
                                    onChange={(e) => setManager(e.target.value)}
                                    className="form-control shadow-none"
                                    id="staticEmail"
                                />
                                {
                                    (errorManager) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger validate-error'>{errorManager}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="row m-3 rahpardaznet-form-controll">
                                <label htmlhtmlFor="staticEmail" className="fw-bold text-end form-label px-1">
                                    تلفن
                                </label>
                                <input
                                    tabIndex="3"
                                    type="text"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    className="form-control shadow-none"
                                    id="staticPhone"
                                />
                                {
                                    (errorPhone) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger validate-error'>{errorPhone}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="row m-3 rahpardaznet-form-controll">
                                <label htmlhtmlFor="staticEmail" className="fw-bold text-end form-label px-1">
                                    کد انبار
                                </label>
                                <input
                                    tabIndex="4"
                                    type="text"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    className="form-control shadow-none"
                                    id="staticEmail"
                                />
                                {
                                    (errorCode) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger validate-error'>{errorCode}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>

                        <div className="col-12 ">
                            <div className="row m-3 rahpardaznet-form-controll">
                                <label htmlhtmlFor="staticEmail" className="fw-bold text-end form-label px-1">
                                    آدرس
                                </label>
                                <input
                                    tabIndex="5"
                                    type="text"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    className="form-control shadow-none"
                                    id="staticEmail"
                                />
                                {
                                    (errorAddress) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger validate-error'>{errorAddress}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div className="row p-0">
                <div className='col-12 p-0'>

                    <button
                        tabIndex='6'
                        onClick={storeSaveHandler}
                        type="submit"
                        className="rahpardaznet-button">
                        {'  تایید درخواست  '}
                    </button>


                </div>
            </div>

        </>
    )
}

export default Archive;